import { Player } from '@core/models/player.models'

export const isGoalKeeper = (player: Player): boolean =>
  player.genericPosition === 'MTR_PLAYERPOSITION_GOALKEEPER' ||
  (player as any).genericPositionKey === 'MTR_PLAYERPOSITION_GOALKEEPER' ||
  (player as any).playerPositionKey === 'MTR_PLAYERPOSITION_GOALKEEPER' ||
  (player as any).playerPosition === 'Goalkeeper'
